import { useEffect, useState } from 'react';
import styled from 'styled-components';

const dropdownOptions = [
  [
    '오늘 공고된 신건',
    '재매각 물건',
    '재진행 물건',
    '감정시점 1년 경과 물건',
    '위반 건축물',
    '맹지',
    '토지건물 일괄매각',
    '토지만 입찰 물건',
    '토지별도등기 있는 물건',
    '토지별도등기 인수조건',
    '건물만 입찰 물건',
    '대지권 미등기',
    '농지취득자격증명',
    '임금채권',
    'NPL(부실채권)',
    '공시가격 1억 이하',
    '최근 2주 변동 물건',
    '반값 경매 물건',
    '반값 공매 물건',
    '반값 NPL 물건',
  ],
  [
    '유치권',
    '유치권 배제',
    '법정지상권',
    '분묘기지권',
    '선순위 가등기',
    '선순위 가처분',
    '지분입찰 물건',
    '예고등기',
  ],
  [
    '선순위 전세권/임차권',
    '임차권 등기',
    '대항력있는 임차인',
    '전세권만 매각',
    'HUG 임차권 인수조건 변경',
  ],
  [
    '유치권에 의한 형식적 경매',
    '기타 형식적경매',
    '공유물 분할을 위한 형식적 경매',
  ],
];

const dropdownTitles = ['물건현황', '권리', '임차인', '형식적경매'];

export const SpecialModal = ({
  isOpen,
  onClose,
  value,
  initialRadio,
  onChangeOption,
}: {
  isOpen: boolean;
  onClose: () => void;
  value: string;
  initialRadio?: 'all' | 'any';
  onChangeOption: (val: ['all' | 'any', string]) => void;
}) => {
  const [selectedOptions, setSelectedOptions] = useState<string[][]>(
    dropdownOptions.map(() => []),
  );

  const [openDropdowns, setOpenDropdowns] = useState<boolean[]>(
    dropdownOptions.map(() => false),
  );

  const [radioChoice, setRadioChoice] = useState<'all' | 'any'>('all');

  const toggleOption = (dropdownIndex: number, option: string) => {
    setSelectedOptions((prev) => {
      const newSelected = prev.map((arr) => [...arr]);
      const idx = newSelected[dropdownIndex].indexOf(option);
      if (idx > -1) {
        newSelected[dropdownIndex].splice(idx, 1);
      } else {
        newSelected[dropdownIndex].push(option);
      }

      return newSelected;
    });
  };

  const toggleDropdown = (idx: number) => {
    setOpenDropdowns((prev) => {
      const newState = [...prev];
      newState[idx] = !newState[idx];
      return newState;
    });
  };

  const handleClose = () => {
    setSelectedOptions(dropdownOptions.map(() => []));
    setRadioChoice('all');
    setOpenDropdowns(dropdownOptions.map(() => false));
    onClose();
  };

  const handleApply = () => {
    const flattened = selectedOptions.flat();

    const result = flattened.join(',');
    onChangeOption([radioChoice, result]);
    onClose();
  };

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  // Sync initial selections/radio from parent when opening
  useEffect(() => {
    if (!isOpen) return;
    // Initialize radio
    setRadioChoice(initialRadio ?? 'all');
    // Initialize selected options
    const items =
      value && value.trim().length > 0
        ? value.split(',').map((s) => s.trim()).filter(Boolean)
        : [];
    const nextSelected = dropdownOptions.map(() => [] as string[]);
    items.forEach((item) => {
      const groupIndex = dropdownOptions.findIndex((group) =>
        group.includes(item),
      );
      if (groupIndex >= 0) {
        nextSelected[groupIndex].push(item);
      }
    });
    setSelectedOptions(nextSelected);
  }, [isOpen, value, initialRadio]);

  if (!isOpen) return null;

  return (
    <ModalOverlay>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <div>
          <Header>
            <CloseButton onClick={handleClose}>
              <img src="/assets/images/arrow/arrow_down.svg" alt="닫기" />
            </CloseButton>
            <h3>특수 조건</h3>
          </Header>

          <Description>
            <p>보기옵션</p>
            <p>선택한 조건을 1개 이상 포함하는 물건을 분석합니다.</p>
            <RadioGroup>
              <label>
                <input
                  type="radio"
                  value="all"
                  checked={radioChoice === 'all'}
                  onChange={() => setRadioChoice('all')}
                />
                <span>모두 포함</span>
              </label>
              <label>
                <input
                  type="radio"
                  value="any"
                  checked={radioChoice === 'any'}
                  onChange={() => setRadioChoice('any')}
                />
                <span>1개 이상 포함</span>
              </label>
            </RadioGroup>
          </Description>

          <DropdownContainer>
            {dropdownOptions.map((options, idx) => (
              <div key={idx}>
                <Dropdown>
                  <DropdownTitle
                    as="button"
                    type="button"
                    onClick={() => toggleDropdown(idx)}
                  >
                    <LeftContent>
                      {dropdownTitles[idx]}
                      {selectedOptions[idx].length > 0 && (
                        <span>+{selectedOptions[idx].length}</span>
                      )}
                    </LeftContent>

                    <ArrowImage
                      isOpen={openDropdowns[idx]}
                      src="assets/images/arrow/arrow_down.svg"
                      alt="arrow"
                    />
                  </DropdownTitle>
                </Dropdown>

                {openDropdowns[idx] && (
                  <OptionsWrapper>
                    <Options>
                      {options.map((option) => (
                        <CheckboxLabel
                          key={option}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <input
                            type="checkbox"
                            checked={selectedOptions[idx].includes(option)}
                            onChange={(e) => {
                              e.stopPropagation();
                              toggleOption(idx, option);
                            }}
                            onClick={(e) => e.stopPropagation()}
                          />
                          <span>{option}</span>
                        </CheckboxLabel>
                      ))}
                    </Options>
                  </OptionsWrapper>
                )}
              </div>
            ))}
          </DropdownContainer>
        </div>
        <div>
          <ButtonContainer>
            <CancleBtn
              type="button"
              onClick={() => {
                setSelectedOptions(dropdownOptions.map(() => []));
                setRadioChoice('all');
                setOpenDropdowns(dropdownOptions.map(() => false));
              }}
            >
              <img src="/assets/images/icon/reset.svg" alt="초기화" />
              초기화
            </CancleBtn>

            <ApplyBtn
              type="button"
              onClick={() => {
                handleApply();
              }}
            >
              특수조건 적용
            </ApplyBtn>
          </ButtonContainer>
        </div>
      </ModalContent>
    </ModalOverlay>
  );
};

const ModalOverlay = styled.div`
  position: fixed;
  max-width: 900px;
  min-height: 100vh;
  overflow-x: hidden;
  margin: 0 auto;
  inset: 0;
  background: #fff;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 16px;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: #fff;
  padding: 6px;
  border-radius: 8px;
  height: 100%;
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;

  img {
    width: 24px;
    rotate: 90deg;
  }
`;

const Description = styled.div`
  p {
    margin: 4px 0;
  }

  p:first-child {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: -0.02em;
    color: #424854;
  }

  p:nth-child(2) {
    font-weight: 500;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: -0.02em;
    color: #787d87;
  }
`;

const RadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 30px;
  margin-top: 8px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;

  label {
    display: flex;
    align-items: center;
    gap: 5px;
    color: #787d87;
    cursor: pointer;

    input {
      margin-right: 5px;
    }

    input:checked + span {
      color: #0c0e12;
    }
  }
`;

const DropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  width: 100%;
`;

const Dropdown = styled.div`
  display: flex;
  background: #f4f5f7;
  border: none;
  outline: none;
  box-shadow: none;
  border-radius: 8px;
  padding: 8px 12px;
  width: 100%;
  height: 48px;
  margin-bottom: 8px;
  cursor: pointer;
`;

const DropdownTitle = styled.div`
  all: unset;
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  cursor: pointer;
`;

const LeftContent = styled.div`
  gap: 4px;

  span {
    position: absolute;
    right: 40px;
    font-weight: 700;
    font-style: Bold;
    font-size: 15px;
    color: #3f6ef1;
  }
`;

const ArrowImage = styled.img<{ isOpen: boolean }>`
  width: 20px;
  height: 20px;
  margin-left: 8px;
  transition: transform 0.2s ease;
  transform: rotate(${(props) => (props.isOpen ? '180deg' : '')});
`;

const CheckboxLabel = styled.label`
  display: block;
  margin-bottom: 10px;

  input {
    margin-right: 6px;
  }

  span {
    color: #787d87;
  }

  input:checked + span {
    color: #0c0e12;
  }
`;

const OptionsWrapper = styled.div`
  position: relative;
  z-index: 2;
`;

const Options = styled.div`
  font-weight: 500;
  font-size: 13px;
  padding: 8px;
  line-height: 20px;
  letter-spacing: -2%;
  color: #787d87;
  display: grid;
  grid-template-columns: 1fr 1fr;
`;

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 10px;
  margin: 10px 0;
`;

const CancleBtn = styled.button`
  display: flex;
  height: 44px;
  gap: 2px;
  angle: 0 deg;
  opacity: 1;
  border-radius: 8px;
  padding-right: 20px;
  padding-left: 18px;
  background: #f4f5f7;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  cursor: pointer;
  border: none;
  outline: none;
  align-items: center;

  img {
    width: 20px;
  }
`;

const ApplyBtn = styled.button<{ disabled?: boolean }>`
  flex: 2;
  height: 44px;
  gap: 10px;
  border-radius: 8px;
  text-align: center;
  background: #000000;
  color: ${({ disabled }) => (disabled ? '#F4F5F74A' : '#fff')};
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  border: none;
  outline: none;
`;
